export enum OrderStatus {
  NEW = "new",
  PLACED = "placed",
  PAID = "paid",
  SHIPPED = "shipped",
  CANCELLED = "cancelled",
}
